import { apiGet, apiPost } from '../standardApi';

export const getContractCancellationContracts = () => {
    return apiGet('/ContractCancellation/GetContracts', 'application/json');
};

export async function apiSendResiliationRequest (body) {
    const response = await apiPost(
      `/ContractCancellation`,
      body,
      '',
      'application/json'
    );
    return response;
  }